import { t } from 'i18next';

import { initialPeriodsTableRow, IPeriodsTableRow } from 'components/BusinessToolForm/constants/periods';
import { getFormTableInitialValues2 } from 'components/BusinessToolForm/utils/helpers';

export const PROFITABILITY_FORM_NAMES = {
  PROFITABILITY_VARIANTS: 'profitabilityVariants',
  CURRENCY: 'currency',
  PROFITABILITY_TABLE: 'profitabilityTable',
  PROFITABILITY_TOTAL: 'profitabilityTotal',
  ANTICIPATED_OUTCOME: 'anticipatedOutcome',
} as const;

export const profitabilityVariants = ['Gross Margin', 'Net Profit Margin', 'EBITDA'];

//  ---- COMMON ----

export interface IProfitabilityFormValuesType {
  [PROFITABILITY_FORM_NAMES.PROFITABILITY_VARIANTS]: string[];
  [PROFITABILITY_FORM_NAMES.PROFITABILITY_TABLE]: IPeriodsTableRow[];
  [PROFITABILITY_FORM_NAMES.PROFITABILITY_TOTAL]: IPeriodsTableRow;
  [PROFITABILITY_FORM_NAMES.ANTICIPATED_OUTCOME]: string;
}

export const profitabilityInitialValues = {
  [PROFITABILITY_FORM_NAMES.PROFITABILITY_VARIANTS]: profitabilityVariants,
  [PROFITABILITY_FORM_NAMES.PROFITABILITY_TABLE]: getFormTableInitialValues2(
    profitabilityVariants.length,
    initialPeriodsTableRow,
  ),
  [PROFITABILITY_FORM_NAMES.PROFITABILITY_TOTAL]: initialPeriodsTableRow,
  [PROFITABILITY_FORM_NAMES.ANTICIPATED_OUTCOME]: '',
};
